
<div ref="bundleWidget" class="bundle-widget-outer-wrapper">
	<PopOver
		:open="isPopOpen"
		:placement="isBottomOpen ? 'bottom-start' : 'right-start'"
		@overlay-click="closePopover()"
	>
		<div class="bundle-widget-wrapper" :tabindex="tabindex" @click="handleClick($event)">
			<!---Header-->
			<div class="bundle-widget-header">
				<div class="display-flex j-c-space-bet">
					<div>
						<p class="title">
							{{ name }}

							<Icon
								name="genric"
								:effects="false"
								type="filled"
								state="primary"
								size="18px"
								class="margin-lt-8"
							/>
						</p>
						<InfoPopover
							placement="bottom-start"
							max-width="340"
							container=".bundle-widget-container"
						>
							<!--Trigger Data-->
							<p class="paragraph-2 fc-light margin-tp-4 last-updated-text">
								{{ lastUpdated.label }}
							</p>
							<!--Trigger Data-->

							<!--Body Data-->
							<template #body>
								<p>{{ lastUpdated.info }}</p>
							</template>
							<!--Body Data-->
						</InfoPopover>
					</div>

					<div>
						<div class="display-flex j-c-end fs-12 bw-dev-services-wrapper">
							<Icon
								v-for="(service, si) in services"
								:key="service.name"
								:name="service"
								type="filled"
								size="18px"
								:class="services.length > si + 1 ? 'margin-rt-12' : ''"
							/>
						</div>

						<div
							class="display-flex j-c-end align-items-center margin-tp-8 bundle-version-list-wrap"
						>
							<!--Pophover element data-->
							<VPopover
								placement="bottom-end"
								container="div.bundle-widget-container"
								popover-class="element bundle-w-pop-version"
							>
								<p class="paragraph-2 cursor-pointer version-icon">
									Version: {{ versions.selected
									}}<Icon
										name="i-triangle-down"
										class="margin-lt-4"
										size="xx-small"
										type="filled"
										state="font-light"
										:effects="false"
									/>
								</p>

								<template v-slot:popover>
									<p
										v-for="(vari, index) in versions.options"
										:key="vari.name"
										v-close-popover
										class="fc-dark display-flex j-c-space-bet align-items-center cursor-pointer"
										:class="versions.options.length > index + 1 ? 'margin-bt-8' : ''"
										@click="selectVersion(vari.name, index)"
									>
										<span class="paragraph-2">{{ vari.name }}</span>
										<span v-if="vari.selected" class="display-flex align-items-center">
											<Icon
												name="i-tick"
												class="margin-lt-8"
												size="x-small"
												type="filled"
												state="dark"
												:effects="false"
											/>
										</span>
									</p>
								</template>
							</VPopover>
							<!-- Pophover element data-->
						</div>

						<div
							class="display-flex j-c-end align-items-center fs-12 margin-tp-8 bw-stats-wrapper"
						>
							<p
								v-for="(information, index) in stats"
								:key="information.id"
								class="paragraph-2 display-flex align-items-center"
							>
								<Icon
									:name="information.icon"
									state="font-light"
									:effects="false"
									size="x-small"
									type="filled"
								/>
								<span class="margin-lt-4">{{ information.data }}</span>
								<span v-if="stats.length > index + 1" class="margin-lt-8 margin-rt-8 fc-light">
									|
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>
			<!---Header-->
			<!---Body-->
			<div v-if="$slots['default']" class="bundle-widget-body">
				<!-- @slot Used for Stats Data For Body-->
				<slot />
			</div>
			<!---Body-->
			<!---Footer-->
			<div class="bundle-widget-footer">
				<div
					class="bundle-widget-project-trigger"
					:class="hoverEffect.left ? '' : 'disabled'"
					@click="openProjectList(hoverEffect.left)"
				>
					<div>
						<span class="inst-text">Intall to </span>
						<p class="name-text">
							{{ currectProject }}
						</p>
					</div>
					<div>
						<Icon
							name="i-setting"
							size="x-small"
							type="filled"
							state="dark"
							@click.stop="projectSetting(currectProject)"
						/>
						<Icon
							:class="isBottomOpen ? 'transtion-icon' : ''"
							name="i-triangle-down"
							size="x-small"
							state="dark"
							class="margin-lt-8"
							type="filled"
							:effects="false"
						/>
					</div>
				</div>
				<div
					class="install-trigger"
					:class="hoverEffect.right ? '' : 'disabled'"
					@click="openInstallList(hoverEffect.right)"
				>
					<span> Install </span>
				</div>
			</div>
			<!---Footer-->
		</div>
		<!-- </div> -->

		<template #content>
			<!--Bundle Install wrapper  Data-->
			<div
				v-if="!isBottomOpen && installOpen"
				class="bundle-widget-install-wrapper"
				:style="{ maxWidth: widthH + 'px', minWidth: widthH + 'px' }"
			>
				<div class="bundle-install-header">
					<span class="display-flex align-items-center">
						<Icon :name="icon" :effects="false" type="filled" size="small" class="margin-rt-4" />
						<h4 class="intall-wrap-title margin-lt-4">{{ currectProject }}</h4>
					</span>

					<span class="display-flex align-items-center">
						<Icon
							name="i-setting"
							type="filled"
							state="dark"
							size="small"
							class=""
							@click="installSetting(currectProject)"
						/>
						<Icon
							name="i-close"
							type="filled"
							state="dark"
							size="small"
							class="margin-lt-16"
							@click="closePopover()"
						/>
					</span>
				</div>
				<!--@slot Used for Install Data -->
				<slot name="install" />
			</div>
			<!--Bundle Install wrapper  Data-->

			<!--Bundle Project list  Data-->
			<div
				v-if="isBottomOpen"
				class="bundle-widget-project-list"
				:style="{ maxWidth: widthH + 'px', minWidth: widthH + 'px' }"
			>
				<div>
					<Slab type="bottom-border" state="default" state-type="solid">
						<p class="paragraph-2">Available Projects</p>
					</Slab>

					<Slab
						v-for="(project, index) in projectList"
						:key="project.vid"
						:type="projectList.length > index + 1 ? 'bottom-border' : 'transparent'"
						size="medium"
						state="default"
						state-type="solid"
						class="cursor-pointer"
						@click="projectSelected(project.name, index, project.iconName)"
					>
						<template #primary-action>
							<Icon
								:name="project.iconName || 'i-genric'"
								:effects="false"
								type="filled"
								size="small"
								class=""
							/>
						</template>
						<p>
							{{ project.name }}
							<span v-if="project.default" class="fc-light">(default project)</span>
						</p>

						<template #secondary-actions>
							<div class="display-flex align-items-center j-c-end">
								<Icon
									name="i-setting"
									class="margin-rt-12"
									size="small"
									type="filled"
									state="dark"
									:effects="true"
									@click.stop="projectSetting(project.name)"
								/>
								<RadioButton :checked="project.checked" />
							</div>
						</template>
					</Slab>
				</div>
			</div>
			<!--Bundle Project list  Data-->
		</template>
	</PopOver>
</div>
